import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Accordion, Card, Button, Form, Container, Row, Col, Spinner, Alert } from 'react-bootstrap';

const EditarHorarios = () => {
  const [localId, setLocalId] = useState(1);
  const [horarios, setHorarios] = useState([]);
  const [error, setError] = useState(null);
  const [savingIndex, setSavingIndex] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const diasSemana = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

  useEffect(() => {
    if (localId) {
      fetchHorarios();
    }
  }, [localId]);

  const fetchHorarios = async () => {
    try {
      const response = await axios.get(`https://pedir-salvatuvianda.p89nps.easypanel.host/horarios/${localId}`);
      setHorarios(response.data);
    } catch (error) {
      setError('Error al obtener horarios.');
    }
  };

  const handleChange = (index, field, value) => {
    const nuevosHorarios = [...horarios];
    nuevosHorarios[index][field] = value;
    setHorarios(nuevosHorarios);
  };

  const handleSaveDay = async (dia, index) => {
    setSavingIndex(index);
    try {
      await axios.put(`https://pedir-salvatuvianda.p89nps.easypanel.host/horarios/${localId}/${dia.dia_semana}`, {
        hora_apertura: dia.hora_apertura,
        hora_cierre: dia.hora_cierre,
        cerrado: dia.cerrado,
      });
      setSuccessMessage(`Horario del ${diasSemana[dia.dia_semana]} actualizado correctamente.`);
      setTimeout(() => setSuccessMessage(null), 3000);
    } catch (error) {
      setError(`Error al actualizar el horario del ${diasSemana[dia.dia_semana]}.`);
    } finally {
      setSavingIndex(null);
    }
  };

  return (
    <Container>
      <h2 className="my-4 text-center">Editar Horarios</h2>

      {/* Selección de sucursal */}
      <Row className="mb-4">
        <Col md={{ span: 6, offset: 3 }}>
          <Form.Group>
            <Form.Label><strong>Selecciona una sucursal:</strong></Form.Label>
            <Form.Select value={localId} onChange={(e) => setLocalId(e.target.value)}>
              <option value={1}>Sucursal 1</option>
              {/* <option value={2}>Sucursal 2</option> */}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      {/* Mensajes de éxito o error */}
      {successMessage && <Alert variant="success" className="text-center">{successMessage}</Alert>}
      {error && <Alert variant="danger" className="text-center">{error}</Alert>}

      {/* Acordeón para mostrar los días */}
      <Accordion>
        {horarios.length > 0 ? (
          horarios.map((dia, index) => (
            <Accordion.Item key={index} eventKey={index.toString()} className={`mb-2 ${dia.cerrado === 1 ? 'bg-light' : ''}`}>
              <Accordion.Header>{diasSemana[dia.dia_semana]}</Accordion.Header>
              <Accordion.Body>
                <Row className="mb-3">
                  <Col xs={12} md={6}>
                    <Form.Group>
                      <Form.Label>Hora Apertura</Form.Label>
                      <Form.Control
                        type="time"
                        value={dia.hora_apertura}
                        onChange={(e) => handleChange(index, 'hora_apertura', e.target.value)}
                        disabled={dia.cerrado === 1}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Group>
                      <Form.Label>Hora Cierre</Form.Label>
                      <Form.Control
                        type="time"
                        value={dia.hora_cierre}
                        onChange={(e) => handleChange(index, 'hora_cierre', e.target.value)}
                        disabled={dia.cerrado === 1}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    label="Cerrado"
                    checked={dia.cerrado === 1}
                    onChange={() => handleChange(index, 'cerrado', dia.cerrado === 1 ? 0 : 1)}
                  />
                </Form.Group>

                <div className="text-end">
                  <Button variant="primary" onClick={() => handleSaveDay(dia, index)} disabled={savingIndex === index}>
                    {savingIndex === index ? (
                      <>
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Guardando...
                      </>
                    ) : (
                      'Aplicar cambios'
                    )}
                  </Button>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          ))
        ) : (
          <p className="text-center mt-3">No hay horarios disponibles para esta sucursal.</p>
        )}
      </Accordion>
    </Container>
  );
};

export default EditarHorarios;
